export const COMPETITOR_TYPE = {
  KEYWORD_COMPETITORS: 0,
  DIRECT_COMPETITORS: 1,
  INDUSTRY_AVERAGE_ONLY: 2,
};
